export default {"src":"/_next/static/media/qr-code.4f29eef8.svg","height":1148,"width":1148,"blurWidth":0,"blurHeight":0};